import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Switch } from '@producer/ui-kit';

import { DescriptionHeader } from '../../features/user/components/description-header';
import { SettingsAction } from '../../features/user/components/settings-action';
import { api } from '../../api';
import { EnvelopeClosedIcon } from '@radix-ui/react-icons';
import { authStore } from '../../core/stores/auth-store';
import { toastPool } from '../../features/toasts/models/toast-pool';
import { Toast } from '../../features/toasts/models/toast';
import { uiStore } from '../../core/stores/ui-store';

export const NotificationPage = observer(() => {
  const user = authStore.currentUser!;

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Notifications settings',
    };

    return () => {
      uiStore.pageTitle = {
        label: '',
      };
    };
  });

  useEffect(() => {
    /*api.get('/me/devices').then((res) => {
      setDevices(res.data);
    });*/
  });

  /*const toggleDesktopNotification = () => {
    if (!('Notification' in window)) {
      return;
    }

    if (Notification.permission === 'granted') {
      console.log('granted');
    } else {
      Notification.requestPermission().then((permission) => {});
    }
  };

  const handleRegisterDevice = () => {
    // Get device token

    api
      .post('/me/devices', {
        token: '',
      })
      .then((res) => {
        setDevices((devices) => [...devices, res.data]);
      });
  };

  const handleDeleteDevice = () => {
    api.delete('/me/devices/:deviceId').then((res) => {
      setDevices((devices) => devices.filter((device) => device._id !== res.data._id));
    });
  };*/

  const handleUpdatePreference = () => {
    const emailPreferences = user.notifications.preferences.find(({ type }) => type === 'email');

    api
      .patch('/me/notifications/preferences', {
        preferences: [
          {
            type: 'email',
            enabled: !emailPreferences?.enabled,
          },
        ],
      })
      .then(({ data }) => {
        user.notifications = data;
      })
      .catch(() => {
        toastPool.insert(
          new Toast('Could not update notification preferences, try again later.', 'error'),
        );
      });
  };

  const emailPreferences = user.notifications.preferences.find(({ type }) => type === 'email');

  return (
    <>
      <DescriptionHeader
        title={'Notifications'}
        description={'Select where you will be notified.'}
      />

      <SettingsAction
        title={'Email notifications'}
        icon={<EnvelopeClosedIcon />}
        action={
          <Switch isToggled={!!emailPreferences?.enabled} onToggle={handleUpdatePreference} />
        }
      />

      {/*<SettingsAction
        title={'Desktop notifications'}
        icon={<Lock />}
        action={<Switch isToggled={true} onToggle={toggleDesktopNotification} />}
      />

      <DescriptionHeader
        title={'Devices'}
        description={'Your registered devices which will receive Producer notifications.'}
      />*/}
    </>
  );
});
